import { createContext, useContext, useState } from "react";

const CardDialogContext = createContext();

export const useCardDialog = () => useContext(CardDialogContext);

export const CardDialogProvider = ({ children }) => {
  const [open, setOpen] = useState(false);

  const openDialog = () => setOpen(true);
  const closeDialog = () => setOpen(false);

  return (
    <CardDialogContext.Provider value={{ open, openDialog, closeDialog }}>
      {children}
    </CardDialogContext.Provider>
  );
};
